// extracted by mini-css-extract-plugin
export default {"footer":"footer__fsaBU","listContainer":"listContainer__CqQ_N"};